import { inject, Pipe, PipeTransform } from '@angular/core';

import { OrderingService } from '@shared/services/ordering.service';

@Pipe({
  name: 'sort',
  standalone: true
})
export class SortPipe implements PipeTransform {
  readonly #orderingService = inject(OrderingService);

  transform<T extends object>(
    list: readonly T[] | null | undefined,
    propertyName: string,
    direction?: 'asc' | 'desc',
    caseSensitive = true
  ): T[] {
    const dir: 'asc' | 'desc' = direction === 'desc' ? 'desc' : 'asc';

    return this.#orderingService.order(list, propertyName, dir, caseSensitive);
  }
}
